import { apiClient } from "@/shared/api/client";

export interface SessionListItem {
  id: string;
  topic: string | null;
  createdAt: string;
  summarizedAt: string | null;
  isActive: boolean;
  game: {
    id: string;
    opponent: string;
    result: string;
    timeControl: string;
    exactTimeControl: string | null;
    playedAt: string;
    analyzed: boolean;
  } | null;
}

export const fetchSessions = (): Promise<SessionListItem[]> => apiClient<SessionListItem[]>("/coach/sessions");

export const deleteSession = (sessionId: string): Promise<void> =>
  apiClient<void>(`/coach/sessions/${sessionId}`, { method: "DELETE" });
